/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewEncapsulation, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { LoginService } from '../../components/login/login.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { SortByPipe } from '../pipes/sorting';

@Component({
  selector: 'cc-save-share-report-modal',
  templateUrl: './save-modal.component.html',
  styleUrls: ['./save-modal.component.scss'],
  providers: [SortByPipe],
  encapsulation: ViewEncapsulation.None
})
export class SaveNdShareReportModalComponent implements OnInit {
  @Input() viewDtls: any;
  @Input() fromDtls: any;
  @Output() onClose = new EventEmitter<any>();
  @ViewChild('saveReportForm') saveReportForm!: NgForm;
  public userData: any = [];
  public selectedUserIds: any = [];
  public reportTagItems: any = [];
  public selectedUserCount = 0;
  public userGroups: any;
  public ngTreeGroups: any = [];
  public filteredTreeGroups: any = [];
  public selectedNodes: any = [];
  public savedReports: any[] = [];
  public user: any;
  public duplicateNamePresent = false;
  private previouslySelectedUserIds: any = [];
  public config = {
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    maxHeight: 400
  };
  private saveAschk: any;
  public saveModalTranslationsObj: any = {};
  public showSearchBox = false;
  private isDesc = true;
  // UI state
  public filterText = '';
  public isSelectAll = false;

  constructor(public bsModalRef: BsModalRef,
    private commonService: CommonService,
    private loginService: LoginService,
    private sortByPipe: SortByPipe,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.saveAschk = this.viewDtls?.name || '';
    if (this.fromDtls.from != 'utility') {
      /*For Bookmarks/Recently viewed share,  these function calls are not required */
      this.getPreselectedUsers();
      this.getAllSavedReports();
    }
    this.getAllUserGroups();
    this.getUserDetails();
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  private getUserDetails() {
    this.user = this.loginService.getUser();
  }

  private getPreselectedUsers() {
    this.previouslySelectedUserIds = [];
    const previouslySelectedUsers = this.viewDtls && this.viewDtls.whomToShare ? this.viewDtls.whomToShare : [];
    if (previouslySelectedUsers && previouslySelectedUsers.length) {
      for (const user of previouslySelectedUsers) {
        this.previouslySelectedUserIds.push(user.emailId);
      }
      this.selectedUserIds = this.previouslySelectedUserIds.length || 0;
    }
  }

  private getAllSavedReports() {
    this.commonService.getAllReports().then(this.getAllSavedReportsSH.bind(this), this.getAllSavedReportsFH.bind(this));
  }

  private getAllSavedReportsSH(response: any) {
    const data = response ? response : '',
      vm = this;
    if (data) {
      this.savedReports = data.filter(function (ele: any) {
        return ele.source.name === vm.fromDtls.sourceType.name;
      });
    }
  }

  private getAllSavedReportsFH(error: any) {
    this.savedReports = [];
    if (error.status == 403) {
      this.bsModalRef.hide();
    }
  }

  public onSelectedChange(selectedUserIds: any) {
    /* Prepare the list of the unique ids form the array */
    const uniqueIds = [];
    for (const id of selectedUserIds) {
      const nodeType = id.split('--')[0],
        nodeValue = id.split('--')[1];
      if (nodeType == 'user' && uniqueIds.indexOf(nodeValue) <= -1) {
        uniqueIds.push(nodeValue);
      }
    }
    this.selectedUserCount = uniqueIds.length || 0;
    this.selectedUserIds = uniqueIds;
  }

  private getAllUserGroups() {
    this.commonService.getAllGroups().then(this.getAllUserGroupsSH.bind(this), this.getAllUserGroupsFH.bind(this));
  }

  private getAllUserGroupsSH(response: any) {
    let items = [];
    items = response;
    this.ngTreeGroups = this.prepareUserGroup(items) || [];
    // Fix: Use the same reference for initial filteredTreeGroups
    this.filteredTreeGroups = this.ngTreeGroups;
    // // initialize filtered view
    // this.filteredTreeGroups = this.removeParentReferences(this.ngTreeGroups);

    // if there were previously selected user ids, pre-select corresponding nodes
    if (this.previouslySelectedUserIds && this.previouslySelectedUserIds.length) {
      const matchingNodes = this.findNodesByData(this.ngTreeGroups, (data: string) => {
        return data?.startsWith('user--') && this.previouslySelectedUserIds.indexOf(data.split('--')[1]) > -1;
      });
      // selectedNodes for p-tree should contain TreeNode references (we found them)
      this.selectedNodes = matchingNodes;
      this.updateSelectedUserIdsFromSelection();
      // set isSelectAll if everything is selected
      const totalUserCount = this.getAllUserNodes(this.ngTreeGroups).length;
      this.isSelectAll = this.selectedUserCount > 0 && (this.selectedUserCount === totalUserCount);
    }
    // this.sortByPipe.transform(this.userGroups, { field: 'text', isDesc: this.isDesc });
    // this.sortByPipe.transform(this.ngTreeGroups, { field: 'label', isDesc: this.isDesc });
  }

  private getAllUserGroupsFH(error: any) {
    if (error.status == 403) {
      this.bsModalRef.hide();
    }
  }

  private prepareUserGroup(userGroups: any) {
    const uGroups: any = [];
    userGroups.map((grp: any, grpIdx: any) => {
      const temp = {
        key: '',
        label: '',
        data: '',
        icon: 'cc_user-group-icon icon-collaborate',
        children: []
      };
      temp.key = grpIdx;
      temp.label = grp.name;
      temp.data = 'group--' + grp.id;

      const children: any = [];
      grp.users.map((usr: any, usrIdx: any) => {
        const userTemp = {
          key: '',
          label: '',
          data: '',
          icon: 'cc_user-icon icon-employee'
        };
        let isCurrentLoggedInUser = false;
        if (usr.id == this.user.id) {
          isCurrentLoggedInUser = true;
        }
        userTemp.key = grpIdx + '-' + usrIdx;
        userTemp.label =
          (usr.firstName || '') +
          ', ' +
          (usr.lastName || '') +
          (isCurrentLoggedInUser ? ' (' + this.getTranslationWithKey('you') + ')' : '');
        userTemp.data = 'user--' + usr.emailId;
        children.push(userTemp);
        if (this.fromDtls.from == 'utility' && isCurrentLoggedInUser) {
          children.pop();
        }
      });
      temp.children = children;
      uGroups.push(temp);
    });

    // const uGroups: any = [];
    // userGroups.map((grp: any, grpIdx: any) => {
    //   const temp = {
    //     key: '',
    //     label: '',
    //     data: '',
    //     icon: 'cc_user-group-icon icon-collaborate',
    //     children: []
    //   };
    //   temp.key = grpIdx;
    //   temp.label = grp.name;
    //   temp.data = 'group--' + grp.id;

    //   const children: any = [];
    //   grp.users.map((usr: any, usrIdx: any) => {
    //     const userTemp = {
    //       key: '',
    //       label: '',
    //       data: '',
    //       icon: 'cc_user-icon icon-employee'
    //     };
    //     let isCurrentLoggedInUser = false;
    //     if (usr.id == this.user.id) {
    //       isCurrentLoggedInUser = true;
    //     }
    //     userTemp.key = grpIdx + '-' + usrIdx;
    //     userTemp.label =
    //       (usr.firstName || '') +
    //       ', ' +
    //       (usr.lastName || '') +
    //       (isCurrentLoggedInUser ? ' (' + this.getTranslationWithKey('you') + ')' : '');
    //     userTemp.data = 'user--' + usr.emailId;
    //     children.push(userTemp);
    //     if (this.fromDtls.from == 'utility' && isCurrentLoggedInUser) {
    //       children.pop();
    //     }
    //   });
    //   temp.children = children;
    //   uGroups.push(temp);
    // });

    /* ngx-treeview userGroups */

    // const groups: TreeviewItem[] = [];
    // for (const group of userGroups) {
    //   let disabled;
    //   if (group.users.length > 0) {
    //     disabled = false;
    //   } else {
    //     disabled = true;
    //   }
    //   const temp = {
    //     text: '',
    //     value: '',
    //     checked: false,
    //     children: [],
    //     disabled: disabled
    //   };
    //   temp.text = group.name + " ( "+ group.users.length+" )";
    //   temp.value = 'group--' + group.id;
    //   const children = [];
    //   for (const user of group.users) {
    //     let checked;
    //     if (this.previouslySelectedUserIds.indexOf(user.emailId) > -1) {
    //       checked = true;
    //     } else {
    //       checked = false;
    //     }
    //     const userTemp = {
    //       text: '',
    //       value: '',
    //       emailId: '',
    //       checked: checked
    //     };
    //     let isCurrentLoggedInUser = false;
    //     if (user.id == this.user.id) {
    //       isCurrentLoggedInUser = true;
    //     }
    //     userTemp.text = (user.firstName || '') + ', ' + (user.lastName || '') + (isCurrentLoggedInUser ? ' ('+this.getTranslationWithKey('you')+')' : '');
    //     userTemp.value = 'user--' + user.emailId;
    //     userTemp.emailId = user.emailId;
    //     const a = new TreeviewItem(userTemp);
    //     children.push(a);
    //     if((this.fromDtls.from == 'utility') && isCurrentLoggedInUser){ /*For Bookmarks/Recently viewed share,  No need to show current user in tree */
    //       children.pop();
    //     }
    //   }

    //   temp.children = children;
    //   const b = new TreeviewItem(temp);
    //   groups.push(b);
    // }

    return uGroups;
  }

  public closeModalWindow() {
    this.onClose.emit({ saved: false });
    this.bsModalRef.hide();
  }

  public onItemAdded(event: any) {
    if (event && event.value) {
      // this.userManageTagsList.forEach(function (userManageTag) {
      //   if (userManageTag.value == event.value && !brkStmt) {
      //     vm.reportTagItems.pop();
      //     brkStmt = true;
      //   }
      // })
    }
  }

  public onItemRemoved(event: any) {
    if (event && event.id) {
      // this.selReportTag.availReportTags.push(event);
      // if (!this.selReportTag.delTags) {
      //   this.selReportTag.delTags = [];
      // }
      // if (event.id) {
      //   this.selReportTag.delTags.push(event);
      // }
    }
  }

  private checkIfDataIsValid() {
    let isValid = true;
    if (this.viewDtls.name && this.viewDtls.name.trim().toString().length > 0) {
      /* Check if the entered name already exists or not */
      let duplicateNamePresent = false;
      for (const report of this.savedReports) {
        if (report.name == this.viewDtls.name && report.id != this.viewDtls.id) {
          isValid = false;
          duplicateNamePresent = true;
          break;
        }
      }
      this.duplicateNamePresent = duplicateNamePresent;
    } else {
      isValid = false;
    }
    return isValid;
  }

  public saveModalContent() {
    const form = this.saveReportForm?.form;
    if ((form?.valid && this.fromDtls.from == 'utility') || this.checkIfDataIsValid()) {
      /*For Bookmarks/Recently viewed share,  No need to validate data */
      if (this.fromDtls.from != 'utility' && this.saveAschk !== this.viewDtls.name) {
        this.viewDtls.id = '';
      }
      this.reportTagItems = this.reportTagItems.map((item: any) => ({ name: item }));
      const response = {
        saved: true,
        nameOfReport: this.viewDtls.name,
        idOfTheReport: this.viewDtls.id || '',
        selectedUserIds: this.selectedUserIds,
        reportTags: this.reportTagItems
      };
      this.onClose.emit(response);
      this.bsModalRef.hide();
    }
  }

  public sortTreeItems() {
    this.isDesc = !this.isDesc;
    // sort root groups alphabetically
    this.filteredTreeGroups.sort((a: any, b: any) => {
      return this.isDesc ? b.label.localeCompare(a.label) : a.label.localeCompare(b.label);
    });
    this.ngTreeGroups.sort((a: any, b: any) => {
      return this.isDesc ? b.label.localeCompare(a.label) : a.label.localeCompare(b.label);
    });
    // also sort children
    const sortRecursive = (nodes: any[]) => {
      nodes.forEach(n => {
        if (n.children && n.children.length) {
          n.children.sort((x: any, y: any) => this.isDesc ? y.label.localeCompare(x.label) : x.label.localeCompare(y.label));
          sortRecursive(n.children);
        }
      });
    };
    sortRecursive(this.filteredTreeGroups);
    sortRecursive(this.ngTreeGroups);
    // this.isDesc = !this.isDesc;
    // this.sortByPipe.transform(this.userGroups, { field: 'text', isDesc: this.isDesc });
    // this.userGroups.forEach((element) => {
    //   if (element['internalChildren']) {
    //     this.sortByPipe.transform(element['internalChildren'], { field: 'text', isDesc: this.isDesc });
    //   }
    // });
  }

  // --- FILTERING ---
  public onFilterTextChange(value: string) {
    this.filterText = value;

    if (!value || value.trim() === '') {
      this.filteredTreeGroups = this.ngTreeGroups;
      return;
    }

    const search = value.toLowerCase();
    this.filteredTreeGroups = this.filterNodes(this.ngTreeGroups, search);
  }

  private filterNodes(nodes: any[], search: string): any[] {
    return nodes
      .map(node => {
        const children = node.children ? this.filterNodes(node.children, search) : [];
        const labelMatches = node.label && node.label.toLowerCase().includes(search);
        if (labelMatches) {
          // If label matches, return the original node (with all children)
          return node;
        } else if (children.length) {
          // If children match, return the original node but with filtered children
          // Only replace children, keep parent reference
          return { ...node, children };
        }
        return null;
      })
      .filter(n => n !== null);
  }

  // Utility to remove parent references for a full tree copy
  private removeParentReferences(nodes: any[]): any[] {
    return nodes.map(node => {
      const { parent, ...clone } = node;
      const clonedNode: any = { ...clone };
      if (node.children) {
        clonedNode.children = this.removeParentReferences(node.children);
      }
      return clonedNode;
    });
  }

  // --- SELECT ALL / CLEAR ---
  public onCheckedChange(checked: boolean) {
    this.isSelectAll = checked;
    if (checked) {
      this.selectedNodes = this.flattenNodes(this.filteredTreeGroups);
    } else {
      this.selectedNodes = [];
    }
    this.updateSelectedUserIdsFromSelection();
  }

  public toggleSelectAll(checked: boolean) {
    this.isSelectAll = checked;
    if (checked) {
      const nodesToSelect = this.filterText
        ? this.getAllNodes(this.filteredTreeGroups)
        : this.getAllNodes(this.ngTreeGroups);

      this.selectedNodes = [];
      nodesToSelect.forEach(node => this.selectNodeRecursive(node));
    } else {
      this.selectedNodes = [];
    }
    this.selectedUserCount = this.countSelectedUsers(this.selectedNodes);
  }

  private selectNodeRecursive(node: any) {
    if (!this.selectedNodes.includes(node)) {
      this.selectedNodes.push(node);
    }
    if (node.children && node.children.length) {
      node.children.forEach((child: any) => this.selectNodeRecursive(child));
    }
  }

  private getAllNodes(nodes: any[]): any[] {
    let result: any[] = [];
    for (const node of nodes) {
      result.push(node);
      if (node.children && node.children.length) {
        result = result.concat(this.getAllNodes(node.children));
      }
    }
    return result;
  }

  public onTreeSelectionChange(selected: any) {
    this.selectedNodes = selected;
    const allNodes = this.filterText ? this.getAllNodes(this.filteredTreeGroups) : this.getAllNodes(this.ngTreeGroups);
    this.isSelectAll = allNodes.length > 0 && allNodes.every(n => this.selectedNodes.includes(n));
    this.selectedUserCount = this.countSelectedUsers(selected);
    const uniqueIds = [];
    for (const id of selected) {
      const nodeType = id.data.split('--')[0],
        nodeValue = id.data.split('--')[1];
      if (nodeType == 'user' && uniqueIds.indexOf(nodeValue) <= -1) {
        uniqueIds.push(nodeValue);
      }
    }
    this.selectedUserCount = uniqueIds.length || 0;
    this.selectedUserIds = uniqueIds;
  }

  private collectAllNodes(node: any, result: any[]) {
    result.push(node);
    if (node.children && node.children.length) {
      node.children.forEach((child: any) => this.collectAllNodes(child, result));
    }
  }

  private countSelectedUsers(nodes: any[]): number {
    return nodes.filter(n => n.data?.startsWith('user--')).length;
  }

  private getAllUserNodes(nodes: any[]): any[] {
    let result: any[] = [];
    for (const n of nodes) {
      if (n.data && typeof n.data === 'string' && n.data.startsWith('user--')) {
        result.push(n);
      }
      if (n.children && n.children.length) {
        result = result.concat(this.getAllUserNodes(n.children));
      }
    }
    return result;
  }

  private flattenNodes(nodes: any[]): any[] {
    let res: any[] = [];
    for (const n of nodes) {
      res.push(n);
      if (n.children && n.children.length) {
        res = res.concat(this.flattenNodes(n.children));
      }
    }
    return res;
  }

  private updateSelectedUserIdsFromSelection() {
    const uniqueUserIds: string[] = [];
    if (!this.selectedNodes) {
      this.selectedUserIds = [];
      this.selectedUserCount = 0;
      return;
    }

    const nodesArray = Array.isArray(this.selectedNodes) ? this.selectedNodes : Object.values(this.selectedNodes || {});

    for (const node of nodesArray) {
      // data format is 'user--email' or 'group--id'
      if (node && node.data && typeof node.data === 'string' && node.data.startsWith('user--')) {
        const email = node.data.split('--')[1];
        if (uniqueUserIds.indexOf(email) === -1) {
          uniqueUserIds.push(email);
        }
      }
    }

    this.selectedUserIds = uniqueUserIds;
    this.selectedUserCount = uniqueUserIds.length;
  }

  private findNodesByData(nodes: any[], predicate: (data: string) => boolean): any[] {
    let found: any[] = [];
    for (const n of nodes) {
      if (n.data && predicate(n.data)) {
        found.push(n);
      }
      if (n.children && n.children.length) {
        found = found.concat(this.findNodesByData(n.children, predicate));
      }
    }
    return found;
  }
}
